import React, {useContext, useEffect} from 'react';
import { Routes, Route, useNavigate, Navigate} from 'react-router-dom';
import Main from '../components/Main';
import { privateRoute } from '.';
import Login from '../components/Login';
import InfoManager from '../components/content/InfoManager';
import { AuthProvider } from '../hooks/useAuth';
import { ProtectedRoute } from './ProtectedRoute';
function AppRouter() {

   return (
      <AuthProvider>
         <Routes>
            <Route path='/login' element={<Login/>}/>
            <Route path="/" element={
                  <ProtectedRoute>
                     <Main />
                  </ProtectedRoute>
            }>
                  <Route path={"/info"} element={<InfoManager/>}/>
                  <Route index element={<Navigate to="/info" />} />
                  {privateRoute.map((route) => (
                     <Route path={route.path} element={route.element} key={route.path} />
                  ))}
            </Route>
         </Routes>
      </AuthProvider>
   )
}

export default AppRouter;